module.exports = __webpack_public_path__ + "bundle/fonts/NotoSerif-Regular.ttf";